import { useStoreConfig } from '~/store/storeConfig'
import type { Currency } from '~/types/storeTypes'
import { CurrencyCode } from '~/types/storeTypes'
import type { SimpleCurrencyInterface } from '~/types/checkoutTypes'
import type { PriceDisplayType } from '~/types/quoteTypes'

export default (
  value?: number | null,
  forcedExchangeRate: number | null = null,
  forcedCurrency: SimpleCurrencyInterface | null = null
): PriceDisplayType => {
  if (typeof value !== 'number') {
    return value
  }

  let selectedCurrency = null

  if (forcedCurrency !== null) {
    selectedCurrency = forcedCurrency
  } else {
    const storeConfig = useStoreConfig()
    const siteCurrency: Currency | null = storeConfig.getConversionCurrency

    if (siteCurrency !== null) {
      selectedCurrency = {
        formatting: siteCurrency.formatting,
        exchange_rate: siteCurrency.exchange_rate,
        iso_code: siteCurrency.iso_code,
      }
    }
  }

  if (!selectedCurrency || !selectedCurrency.formatting) {
    return value
  }

  let exchangeRate = selectedCurrency.exchange_rate
  if (forcedExchangeRate) {
    exchangeRate = forcedExchangeRate
  }

  let convertedValue = +(value * (exchangeRate || 1)).toFixed(6)
  const isNegative = +convertedValue < 0

  if (isNegative) {
    convertedValue = convertedValue * -1
  }

  const newConvertedValue: string = convertedValue.toFixed(2)

  let newValue = selectedCurrency.formatting.replace('{amount}', `${newConvertedValue} `).trim()

  newValue = selectedCurrency.iso_code === CurrencyCode.Eur ? newValue.replace(/\./g, ',') : newValue

  return isNegative ? `-${newValue}` : newValue
}
